import { render, staticRenderFns } from "./ArtListItemAFA.vue?vue&type=template&id=e07ced54&"
import script from "./ArtListItemAFA.vue?vue&type=script&lang=js&"
export * from "./ArtListItemAFA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports